<form #filterForm="ngForm">
  <div class="flex flex-wrap justify-start lg:justify-end gap-4 items-start">
    <!-- Group Discard button as-is -->
    <button
      class="py-1 px-5 border border-[#d9d9d9] rounded"
      (click)="onGroupDiscardClick()"
      [disabled]="selectedFiling.length < 2"
      [ngClass]="{
        'bg-[#1f273b] text-white cursor-pointer hover:bg-[#2a334a]':
          selectedFiling.length >= 2,
        'bg-white text-gray-800 cursor-not-allowed': selectedFiling.length < 2
      }"
      pTooltip="{{
        selectedFiling.length < 2
          ? 'Select at least two rows to enable grouping'
          : ''
      }}"
      tooltipPosition="top"
      type="button"
    >
      Group Discard
    </button>

    <!-- Date range picker -->
    <div class="flex flex-col w-full sm:w-auto">
      <p-datepicker
        [(ngModel)]="rangeDates"
        name="rangeDates"
        selectionMode="range"
        clearButtonStyleClass="bg-red right-4 ml-6 text-red"
        [inputStyle]="{
          border: 'none',
          paddingLeft: '0',
          paddingRight: '0',
          paddingTop:'0',
          paddingBottom:''
        }"
        [styleClass]="
          'peer block px-0 pr-10 w-full text-sm text-gray-900 appearance-none border-0 border-b-2 focus:outline-none focus:ring-0 border-gray-300 focus:border-[#1f273b]'
        "
        (onSelect)="onDateChange()"
        (onClear)="onDateChange()"
        placeholder="Search by date"
        showClear="true"
      ></p-datepicker>
    </div>
   <!-- Filing Id + validation -->
<div class="flex flex-col w-full sm:w-auto">
  <input
    type="text"
    name="filingId"
    placeholder="Search by filing Id"
    [(ngModel)]="filingIdInput"
    #filingIdCtrl="ngModel"
    pattern="^[0-9]*$"
    (keydown)="preventSpaceKey($event)"
    (keydown.enter)="onSearch(filterForm)"
    (paste)="onPaste($event, 'filingIdInput')"

    class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529]
           px-1 py-1.5 placeholder-gray-400 w-full sm:w-auto"
  />
    <small
      class="text-red-600 mt-1"
      *ngIf="filingIdCtrl.invalid && (filingIdCtrl.dirty || filingIdCtrl.touched)"
    >
      Filing ID must be an integer.
    </small>
</div>

    <!-- Issuer Name + error -->
    <div class="flex flex-col w-full sm:w-auto">
      <input
        type="text"
        name="issuerName"
        placeholder="Search by issuer name"
        [(ngModel)]="issuerNameInput"
        #issuerNameCtrl="ngModel"
        pattern=".*\S.*"
        (keydown.enter)="onSearch(filterForm)"
          (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'issuerNameInput')"
        class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1.5 placeholder-gray-400"
      />

      <div
        *ngIf="
          issuerNameCtrl.invalid &&
          (issuerNameCtrl.dirty || issuerNameCtrl.touched)
        "
        class="text-xs text-red-500 mt-1"
      >
        <span *ngIf="issuerNameCtrl.errors?.['pattern']">
          Issuer name cannot be only spaces.
        </span>
      </div>
    </div>

    <!-- Form Type -->
    <div class="flex flex-col w-full sm:w-auto">
      <select
        name="formType"
        [(ngModel)]="selectedFormType"
        (change)="onSearch(filterForm)"
        class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1.5 placeholder-gray-400"
      >
        <option [ngValue]="undefined">Select form type</option>
        <option *ngFor="let type of formTypes" [ngValue]="type">
          {{ type }}
        </option>
      </select>
    </div>

    <button
      type="button"
      class="w-10 h-10 flex items-center justify-center border border-[#d9d9d9] rounded
     bg-[#1f273b] text-white cursor-pointer hover:bg-[#2a334a]
     flex-shrink-0 text-2xl font-semibold leading-none"
      (click)="openManualFilingForm()"
    >
      +
    </button>



  </div>
</form>

<p-dialog
  header="Add Manual Filing"
  [(visible)]="showManualFilingDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '550px' }"
>
  <form
    #manualFilingForm="ngForm"
    (ngSubmit)="submitManualFiling(manualFilingForm)"
  >

    <!-- Company Name -->
    <div class="flex flex-col mb-4">
      <label class="text-sm font-medium mb-1">
        Company Name
      </label>

      <input
        type="text"
        name="companyName"
        [(ngModel)]="manualFiling.companyName"
        required
        class="text-sm border border-gray-300 rounded px-3 py-2
               focus:outline-none focus:border-[#1f273b]"
        placeholder="Enter company name"
      />
    </div>

    <!-- Filing Date -->
    <div class="flex flex-col mb-4">
      <label class="text-sm font-medium mb-1">
        Filing Date
      </label>

      <input
        type="date"
        name="filingDate"
        [(ngModel)]="manualFiling.filingDate"
        required
        class="text-sm border border-gray-300 rounded px-3 py-2
               focus:outline-none focus:border-[#1f273b]"
      />
    </div>

    <!-- Source URL -->
    <div class="flex flex-col mb-4">
      <label class="text-sm font-medium mb-1">
        Source URL
      </label>

      <input
        type="text"
        name="sourceUrl"
        [(ngModel)]="manualFiling.sourceUrl"
        required
        class="text-sm border border-gray-300 rounded px-3 py-2
               focus:outline-none focus:border-[#1f273b]"
        placeholder="Enter source URL"
      />
    </div>

    <!-- Text -->
    <div class="flex flex-col mb-4">
      <label class="text-sm font-medium mb-1">
        Text
      </label>

      <textarea
        name="text"
        [(ngModel)]="manualFiling.text"
        required
        rows="6"
        class="text-sm border border-gray-300 rounded px-3 py-2
               focus:outline-none focus:border-[#1f273b]"
        placeholder="Enter filing text"
      ></textarea>
    </div>

    <!-- Buttons -->
    <div class="flex justify-end gap-3 mt-5">

      <button
        type="button"
        class="px-5 py-2 border border-gray-300 rounded
               text-gray-700 hover:bg-gray-100"
        (click)="closeManualFilingForm()"
      >
        Cancel
      </button>

      <button
        type="submit"
        class="px-5 py-2 rounded bg-[#1f273b] text-white
               hover:bg-[#2a334a]"
        [disabled]="manualFilingForm.invalid || isSubmittingManualFiling"
      >
        {{ isSubmittingManualFiling ? 'Saving...' : 'Submit' }}
      </button>

    </div>

  </form>
</p-dialog>


<div class="mb-4"></div>
<p-table
  [value]="filings"
  [paginator]="filings.length > 0"
  [first]="first"
  (onLazyLoad)="loadData($event)"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [loading]="isLoading"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  [(selection)]="selectedFiling"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [rowsPerPageOptions]="[10, 25, 50]"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4rem">
        <p-tableHeaderCheckbox />
      </th>
      <th>Filing ID</th>
      <th>Form Type</th>
      <th>Accession Number</th>
      <th>Issuer Name</th>
      <th>AI Response</th>
      <th>Text Grabbed</th>
      <th>Source URL</th>
      <th>Locked</th>
      <th>Discard</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-filing>
    <tr>
      <td>
        <p-tableCheckbox [value]="filing" />
      </td>
      <td>
        <span
          (click)="
            filing.lockedBy && filing.lockedBy != thisUser
              ? null
              : openAddModal(filing)
          "
          [style.color]="
            filing.lockedBy && filing.lockedBy != thisUser ? '#999' : '#4a90e2'
          "
          [style.text-decoration]="
            filing.lockedBy && filing.lockedBy != thisUser
              ? 'none'
              : 'underline'
          "
          [style.cursor]="
            filing.lockedBy && filing.lockedBy != thisUser
              ? 'default'
              : 'pointer'
          "
        >
          {{ filing.filingId }}
        </span>
      </td>
      <td>{{ filing.formType }}</td>
      <td>{{ filing.accessionNumber }}</td>
      <td>{{ filing.issuerName }}</td>
      <td>{{ filing.aiResponse }}</td>
      <td
        style="
          max-width: 250px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        "
      >
        <span
          [pTooltip]="filing.textGrabbed"
          tooltipPosition="top"
          [tooltipStyleClass]="'custom-tooltip'"
          [autoHide]="false"
          [tooltipDisabled]="!filing.textGrabbed"
          class="block overflow-hidden text-ellipsis whitespace-nowrap"
        >
          {{ filing.textGrabbed }}
        </span>
      </td>

      <td>
        <a
          href="{{ filing.sourceUrl }}"
          *ngIf="filing.sourceUrl"
          target="_blank"
          >Link</a
        >

        <span *ngIf="!filing.sourceUrl">-</span>
      </td>
      <td>
        <i
          *ngIf="filing.lockedBy; else unlocked"
          class="pi pi-lock text-red-500"
          pTooltip="Locked by {{
            filing.lockedBy != thisUser ? filing.lockedBy : 'you.'
          }}"
          tooltipPosition="top"
          style="cursor: pointer"
          (click)="confirmUnlock(filing)"
        ></i>

        <ng-template #unlocked>
          <i
            class="pi pi-unlock text-green-600"
            (click)="lockFile(filing)"
            style="cursor: pointer"
            pTooltip="Click to edit"
            tooltipPosition="top"
          ></i>
        </ng-template>
      </td>
      <td>
        <button
          class="row-action-button danger"
          (click)="discardFiling(filing)"
          pTooltip="Discard filing"
          tooltipPosition="top"
          [disabled]="shouldDisableRowAction(filing)"
        >
          <i class="pi pi-trash"></i>
        </button>
        <!-- <button
          pButton
          type="button "
          icon="pi pi-trash"
          class="p-button-text p-button-danger row-action-button"
          (click)="discardFiling(filing)"
          [disabled]="shouldDisableRowAction(filing)"
        ></button> -->
      </td>
    </tr>
  </ng-template>
</p-table>
<ng-container *ngIf="!isLoading && filings.length === 0">
  <div class="text-center py-6 text-gray-500">No record found</div>
</ng-container>
<app-add-data
  [filing]="filing"
  *ngIf="displayAddModal"
  (closeModal)="onDialogHide($event)"
  (filingId)="unlockFileFromValidateForm($event)"
></app-add-data>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
